var render = function (_h,_vm) {var _c=_vm._c;return _c('a',_vm._b({staticClass:"al-link",attrs:{"target":"_blank","rel":"noopener noreferrer"}},'a',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }